import {Component,Input,SimpleChanges,  Output, EventEmitter} from '@angular/core';
import { FormBuilder, FormGroup,FormArray } from '@angular/forms';
import { FormEditor } from '../../../../shared/utils/form-editor';



@Component({
    selector: 'mh-customer-hotel-images-form',
    templateUrl: './hotel-images-form.component.html',
    styleUrls: ['./hotel-images-form.component.scss'],
    providers: [FormEditor],
    standalone: false
})
export class CustomerHotelImagesFormComponent{

  @Input()
  parentForm:FormGroup;

  @Input()
  hotelBase;

  @Input()
  viewType;

  @Input()
  hotelDto;

  @Input()
  disabled=false;



  @Output()
  isReady: EventEmitter<string> = new EventEmitter();

  @Output()
  waiting: EventEmitter<boolean> = new EventEmitter();


  constructor(private fb: FormBuilder) {

  }

  ngOnInit(){
    this.isReady.emit("images");
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.hotelDto !== undefined) this.setFormImages();
  }

  setFormImages() {
    let control = <FormArray>this.parentForm.controls.images;
    
    // Crear un Set para almacenar los IDs ya agregados
    const existingIds = new Set(control.value.map(img => img.id));
    
    this.hotelDto.images.forEach(image => {
      // Solo agregar la imagen si su ID no existe ya
      if (!existingIds.has(image.id)) {
        control.push(this.fb.group({
          deleted: image.deleted,
          description: image.description, 
          id: image.id,
          logo: image.logo,
          path: image.path,
          url: image.url,
          raw: {data:null}
        }));
        existingIds.add(image.id);
      }
    });
  }

  get images() {           return <FormArray>this.parentForm.get('images'); }

  updateImage($event, image){
    image.controls['raw'].setValue($event,{emitEvent: true});
  }

  changedImage(state:boolean){
    this.waiting.emit(state);
  }

}
